import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "text-red-500 base" };
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ErrorModal',
    props: {
        isShown: Boolean,
        errorMessage: String,
    },
    emits: ["close"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (__props.isShown)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    onClose: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('close')); })
                }, {
                    body: _withCtx(function () { return [
                        _createElementVNode("h1", _hoisted_1, [
                            _createVNode(_component_font_awesome_icon, {
                                icon: "fa-solid fa-exclamation",
                                size: "2xl",
                                style: { "color": "#dc2626" }
                            }),
                            _createTextVNode(" " + _toDisplayString(__props.errorMessage), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
